export default {
	/**
	 * Resolves an array of group objects from the API.
	 *
	 * @param {int} clientId THe client ID
	 * @returns {Promise<array>}
	 */
	async all (clientId) {},

	/**
	 * Resolves a single group from the given ID.
	 *
	 * @param {int} clientId The client ID
	 * @param {int} id The group ID to retrieve
	 * @returns {Promise<object>}
	 */
	async find (clientId, id) {},

	/**
	 * Resolves a single group with joined device types from the given ID.
	 *
	 * @param {int} clientId The client ID
	 * @param {int} id The group ID to retrieve
	 * @returns {Promise<object>}
	 */
	async findWithDeviceTypes (clientId, id) {},

	/**
	 * Stores a new group under the given client ID.
	 *
	 * @param {int} clientId The client ID
	 * @param {string} name The name of the group to store
	 * @param {int|null} parentId The parent ID of the group to store.
	 * @param {boolean} isActive Active flag of the group to store
	 * @returns {Promise<object>}
	 */
	async store (clientId, name, parentId, isActive) {},

	/**
	 * Updates the given group under the given client ID.
	 *
	 * @param {int} clientId The client ID
	 * @param {string} name The name of the group to store
	 * @param {int|null} parentId The parent ID of the group to store.
	 * @param {boolean} isActive Active flag of the group to store
	 * @returns {Promise<object>}
	 */
	async update (groupId, clientId, name, parentId, isActive) {},

	/**
	 * Retrieves an array of monitors from the given client and group ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @returns {Promise<array>}
	 */
	async getMonitors (clientId, groupId) {},

	/**
	 * Retrieves an array of monitor types from the given group ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 */
	async getMonitorTypes (clientId, groupId) {},

	/**
	 * Retrieves the given monitor type from the given client ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {string} monitorType The monitor type key
	 * @param {object} settings The settings to be sent with the query
	 */
	async getMonitorType (clientId, groupId, monitorType, settings) {},

	/**
	 * Retrieves an array of inherited monitors from the given client and group ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @returns {Promise<array>}
	 */
	async getInheritedMonitors (clientId, groupId) {},

	/**
	 * retrieves the notifications for a group
	 *
	 * @param clientId
	 * @returns {Promise<Array|Object|string>}
	 */
	async getNotifications (groupId) {}
};
